import { isUserPermitted } from '../../../../../auth/components/UserRoleGuard/utils';

export const determineIsTemplateVisibleToUser = (
  inventoryTemplate: InventoryTopology,
  userRoles?: UserRole[],
): boolean =>
  inventoryTemplate.visibility === 'ALL_USERS' ||
  (inventoryTemplate.visibility === 'DEVELOPER' &&
    isUserPermitted(userRoles, ['ROLE_ADMIN', 'ROLE_DEVELOPER']));

export const mapInventoryTemplate = (
  inventoryTemplate: InventoryTopology,
): InventoryTopology => {
  const {
    architectures,
    originalName,
    originalDescription,
    name = originalName,
    description = originalDescription,
  } = inventoryTemplate;

  return {
    ...inventoryTemplate,
    architectureNames: architectures?.map(
      ({ name: architectureName = '' }: Architecture) => architectureName,
    ),
    description,
    name,
  };
};
